import React from "react";
import { ETAPA_LABELS } from "../../../utils/toc/etapas";
import {
  EmptyHint,
  PlaybookBody,
  PlaybookHint,
  PlaybookItem,
  PlaybookList,
  PlaybookStepNumber,
  SectionH2,
  SectionHeader,
} from "./styles";

const PASSOS = ["identificar", "explorar", "subordinar", "elevar", "repetir"];

export default function PlaybookPanel({ etapa, playbook }) {
  if (!etapa || !playbook) {
    return (
      <EmptyHint id="playbook">
        Sem gargalo detectado — nenhum playbook em destaque.
      </EmptyHint>
    );
  }

  return (
    <section id="playbook" aria-label="Playbook do gargalo atual">
      <SectionHeader>
        <SectionH2>
          Playbook · 5 passos de foco para {ETAPA_LABELS[etapa]}
        </SectionH2>
      </SectionHeader>
      <PlaybookList>
        {PASSOS.map((chave, index) => {
          const passo = playbook[chave];
          if (!passo) return null;
          const isFirst = index === 0;
          return (
            <PlaybookItem key={chave} open={isFirst}>
              <summary>
                <PlaybookStepNumber>{index + 1}</PlaybookStepNumber>
                {passo.titulo}
              </summary>
              <PlaybookBody>
                {passo.acao}
                {passo.ondeNoApp && (
                  <PlaybookHint>Onde olhar: {passo.ondeNoApp}</PlaybookHint>
                )}
              </PlaybookBody>
            </PlaybookItem>
          );
        })}
      </PlaybookList>
    </section>
  );
}
